export const formatDateTime = (iso: string) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${dd}/${mm}/${yyyy} - ${hh}:${min}`;
};

export const formatDuration = (
  fromHour: string | null,
  toHour: string | null
): string => {
  if (!fromHour || !toHour) return "—";
  const [fh, fm] = fromHour.split(":").map(Number);
  const [th, tm] = toHour.split(":").map(Number);
  if ([fh, fm, th, tm].some((n) => Number.isNaN(n))) return "—";
  let minutes = th * 60 + tm - (fh * 60 + fm);
  if (minutes < 0) minutes += 24 * 60;
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  return remainder === 0
    ? `${hours} H`
    : `${hours}h${String(remainder).padStart(2, "0")}`;
};
